import { Card } from "../../components/Card";
import { PROMO_EACH, PROMO_TRIPLE } from "./constants";

export function PromotionsIntroCard({ doneTriple }) {
  return (
    <Card
      variant="light"
      className="promotionsPinnedIntro"
      title="Закреплённые акции"
      subtitle={`Три шага с бонусом по ${PROMO_EACH}: ФИО, дата рождения, телефон. Четвёртый шаг — подписка на наш канал в Telegram (отдельных ${PROMO_EACH} за него нет). Выполни все четыре — получишь ещё +${PROMO_TRIPLE} 🎁.`}
    >
      <p className="errorMessage">
        Все бонусы стартовых акций начисляются через 24 часа после выполнения соответствующего шага
        (включая бонус +{PROMO_TRIPLE} за комплект из 4 шагов).
      </p>
      {doneTriple ? (
        <p className="successMessage promotionsPinnedIntro__done">
          Все четыре шага пройдены, бонус +{PROMO_TRIPLE} за комплект начислен.
        </p>
      ) : null}
    </Card>
  );
}
